<template>
  <div class="constraint-settings">
    <div class="constraint-settings-row">
      <span class="constraint-settings-title">Max. Wind Speed (kn)</span>
      <div class="constraint-settings-row-item">
        <ThemedTextField
          v-model="maxWindCruiseSpeedModel"
          label="Cruise"
          outlined
          persistent-placeholder
          type="number"
        />
        <ThemedTextField
          v-model="maxWindServiceSpeedModel"
          label="Service"
          outlined
          persistent-placeholder
          type="number"
        />
      </div>
    </div>
    <div class="constraint-settings-row">
      <span class="constraint-settings-title">Max. Wave Height (m)</span>
      <div class="constraint-settings-row-item">
        <ThemedTextField
          v-model="maxWaveCruiseHeightModel"
          label="Cruise"
          outlined
          persistent-placeholder
          type="number"
        />
        <ThemedTextField
          v-model="maxWaveServiceHeightModel"
          label="Service"
          outlined
          persistent-placeholder
          type="number"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ThemedTextField from "@/core/ThemedTextField.vue";
export default {
  name: "ConstraintSettings",
  components: {
    ThemedTextField,
  },
  data: function () {
    return {};
  },
  computed: {
    ...mapState("weatherRouting/formModule", [
      "maxWindCruiseSpeed",
      "maxWindServiceSpeed",
      "maxWaveCruiseHeight",
      "maxWaveServiceHeight",
    ]),
    maxWindCruiseSpeedModel: {
      get() {
        return this.maxWindCruiseSpeed;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/formModule/SET_MAX_WIND_CRUISE_SPEED",
          value,
          { root: true }
        );
      },
    },
    maxWindServiceSpeedModel: {
      get() {
        return this.maxWindServiceSpeed;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/formModule/SET_MAX_WIND_SERVICE_SPEED",
          value,
          { root: true }
        );
      },
    },
    maxWaveCruiseHeightModel: {
      get() {
        return this.maxWaveCruiseHeight;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/formModule/SET_MAX_WAVE_CRUISE_HEIGHT",
          value,
          {
            root: true,
          }
        );
      },
    },
    maxWaveServiceHeightModel: {
      get() {
        return this.maxWaveServiceHeight;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/formModule/SET_MAX_WAVE_SERVICE_HEIGHT",
          value,
          {
            root: true,
          }
        );
      },
    },
  },
};
</script>

<style scoped>
.constraint-settings {
  background-color: var(--color-surface);
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.constraint-settings-row {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: start;
}

.constraint-settings-row-item {
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.constraint-settings-title {
  font-size: 14px;
  font-weight: 600;
  flex-grow: 2;
  color: var(--color-text);
  min-width: 150px;
}
</style>
